import { CanDeactivateFn } from '@angular/router';

import PublicApiComponent from './public-api.component';

export const publicApiLeaveGuard: CanDeactivateFn<PublicApiComponent> = (component) =>
  component.canLeavePage();
